/**
 * 生成UUID
 * @returns {string}
 */
export const uuid = () => {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}

/**
 * 复制内容
 * */
export function tCopyContent (str) {
  if (!str) {
    return this.$message.success('No content is copied')
  }
  this.$copyText(str)
    .then(e => {
        this.$message.success('Copy success')
      }, function (e) {
        this.$message.fail('Copy failed, please copy manually！')
      }
    )
}

// utils.js

export function buildDataList (items, parentId) {
  const result = []

  for (const item of items) {
    if (item.pid === parentId) {
      const option = {
        value: item.id,
        label: item.title
      }
      const newItem = {...option}
      const children = buildDataList(items, item.id)
      if (children.length > 0) {
        newItem.children = children
      }
      result.push(newItem)
    }
  }
  return result
}

// utils.js

export function buildArrList (items, parentId) {
  const result = []

  for (const item of items) {
    if (item.pid === parentId) {
      const newItem = {...item}
      const children = buildArrList(items, item.id)
      if (children.length > 0) {
        newItem.children = children
      }
      result.push(newItem)
    }
  }

  return result
}

export function findOptionPath (options, itemId, path = []) {
  let selectId = parseInt(itemId)
  for (const option of options) {
    const currentPath = [...path, option.value]
    if (option.value === selectId) {
      return currentPath // 返回完整的选项路径
    }
    if (option.children) {
      const childPath = findOptionPath(option.children, selectId, currentPath)
      if (childPath) {
        return childPath // 如果在子级中找到了选项，则返回子级的路径
      }
    }
  }
  return null // 如果找不到选项，则返回 null 或其他适当的值
}

// scrollUtils.js

export function scrollToTop (duration = 800) {
  const startY = window.scrollY
  const distance = 0 - startY
  let startTime = null

  function animate (currentTime) {
    if (!startTime) {
      startTime = currentTime
    }

    const progress = currentTime - startTime
    const easeInOutCubic = t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    const scrollPosition = easeInOutCubic(progress / duration) * distance + startY

    window.scrollTo(0, scrollPosition)

    if (progress < duration) {
      requestAnimationFrame(animate)
    }
  }

  requestAnimationFrame(animate)
}

/**
 * 获取运行环境
 * @returns {string}
 */
export function getProcess () {
  return process.env.NODE_ENV === 'production' ? 'https://fulfillment.printbelle.com/prod_api' : 'http://192.168.50.148:8112'
}

/**
 * 根据id筛选出对应名称
 * @param list
 * @param targetId
 * @returns {null|*}
 */
export function getIdByName (list, targetId) {
  const foundItem = list.find(item => parseInt(item.id) === parseInt(targetId))
  return foundItem ? foundItem.name : 'Product'
}

/**
 * 组装数据
 * @param originalData
 * @returns {{name: string, itemList: *}[]}
 */
export function setDataToSpecs (originalData) {
  const specsMap = {}
  const otherList = new Map()

  for (const item of originalData) {
    for (const property of item.specOptionVOS) {
      const name = property.specsName
      if (!specsMap[name]) {
        specsMap[name] = []
      }
      const value = property.optionName
      const key = name + value
      if (!specsMap[name].includes(key)) {
        specsMap[name].push(key)
        otherList.set(key, {
          name: value,
          colorValue: property.colorValue,
          imgUrl: property.imgUrl
        })
      }
    }
  }
  const specs = Object.keys(specsMap).map((name, index) => ({
    name,
    item: specsMap[name].map((key, subIndex) => (otherList.get(key)))
  }))
  return specs
}

/**
 * 根据id匹配选中数据
 * @param data
 * @param defaultProductId
 * @returns {[]|*[]}
 */
export function getVariantDataById (data, defaultProductId) {
  for (const item of data) {
    if (parseInt(item.id) === parseInt(defaultProductId)) {
      return item
    }
  }
  return []
}

/**
 * 组装数据
 * @param productVO
 * @returns {{difference: *, id: *}[]}
 */
export function setDifferenceArray (productVO) {
  return productVO.flatMap(variant => {
    const properties = variant.specOptionVOS.map(prop => `${prop.optionName}`)
    return {
      id: variant.id,
      difference: properties.join(',')
    }
  })
}

/**
 * 判断对象和id是否为空
 * @param obj
 * @returns {boolean}
 */
export function isIdEmpty (obj) {
  return !obj || !obj.id // Return true if object is null, undefined, or id is empty
}

/**
 * 判断是否有该字段
 * @param obj
 * @param field
 * @returns {boolean}
 */
export const hasField = (obj, field) => {
  return obj.hasOwnProperty(field)
}

/**
 * 判断元素是否在可视范围内
 * @param el
 * @returns {boolean}
 */
export function isElementNotInViewport (el) {
  if (el) {
    const rect = el.getBoundingClientRect()
    return (
      rect.top >=
      (window.innerHeight || document.documentElement.clientHeight) ||
      rect.bottom <= 0
    )
  }
}

function getItemNamesById (data, id) {
  const result = []

  function processItem (item) {
    if (item.id === id) {
      result.push(item.name)
    }

    if (item.children && item.children.length > 0) {
      for (const child of item.children) {
        processItem(child)
      }
    }
  }

  for (const item of data) {
    processItem(item)
  }

  return result
}

export function getItemsById (data, id) {
  const result = []

  function processItem (item) {
    if (item.id === id) {
      result.push(item)
    }

    if (item.children && item.children.length > 0) {
      for (const child of item.children) {
        processItem(child)
      }
    }
  }

  for (const item of data) {
    processItem(item)
  }
  return result
}

export function getNamesById (data, id) {
  const result = []

  function processItem (item, parentNames) {
    const currentNames = [...parentNames, item.name]
    if (item.id === id) {
      result.push(currentNames)
    }

    if (item.children && item.children.length > 0) {
      for (const child of item.children) {
        processItem(child, currentNames)
      }
    }
  }

  for (const item of data) {
    processItem(item, [])
  }

  return result[0]
}

export function getCartesianProduct (array) {
  return array.reduce((a, b, c) => {
    const res = []
    a.map(x => {
      b.data.map(y => {
        res.push({...x, [b.name]: y})
      })
    })
    return res
  }, [{}])
}

/**
 * 乱序排序
 * @param arr
 */
export function shuffle (arr) {
  arr.sort(() => Math.random() - 0.5)
}

/**
 * 获取随机数
 *
 * @param min
 * @param max
 * @returns {*}
 */
export function getRandom (min, max) {
  const floatRandom = Math.random()
  const difference = max - min
  // 介于 0 和差值之间的随机数
  const random = Math.round(difference * floatRandom)
  const randomWithinRange = random + min
  return randomWithinRange
}

/**
 * 获取随机数
 *
 * @param min
 * @param max
 * @returns {*}
 */
export function getRandomInt (min, max) {
  const randomWithinRange = getRandom(min, max)
  return Math.round(randomWithinRange)
}

/**
 * 加载：Google tag (gtag.js)
 * @param {number}
 * @param id
 */
export function loadGTM (id) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })
    // eslint-disable-next-line one-var
    let f = d.getElementsByTagName('head')[0],
      // eslint-disable-next-line eqeqeq
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.appendChild(j)
  })(window, document, 'script', 'dataLayer', id)
}

/**
 * 加载script dom结构
 *
 * @param scriptDom
 */
export function loadScriptDom (scriptDom) {
  if (scriptDom) {
    document.getElementsByTagName('head')[0].appendChild(scriptDom)
    console.log(`加载自定义 js, src:${scriptDom.src}, text:${scriptDom.text}`)
  }
}

/**
 * 加载script text
 *
 * @param {string}
 * @param scriptText
 */
export function loadScriptText (scriptText) {
  if (scriptText && scriptText.trim()) {
    let scriptDom = document.createElement('script')
    scriptDom.type = 'text/javascript'
    scriptDom.text = scriptText
    loadScriptDom(scriptDom)
  }
}

/**
 * 记载自定义JS文本：包含script 远程地址 dom，以及script 包含文本
 *
 * @param customJs
 */
export function loadCustomScript (customJs) {
  // 创建一个新的 div 元素
  const tempDivDom = document.createElement('div')
  // 将字符串作为 HTML 插入到新的 div 中
  tempDivDom.innerHTML = customJs
  // 遍历新 div 中的所有 script 元素
  Array.from(tempDivDom.getElementsByTagName('script')).forEach(script => {
    // 如果该 script 元素有 src 属性，则动态引入外部 JavaScript
    if (script.src) {
      const newScript = document.createElement('script')
      for (let i = 0; i < script.attributes.length; i++) {
        const attr = script.attributes[i]
        newScript.setAttribute(attr.name, attr.value)
      }
      loadScriptDom(newScript)
    } else {
      // 否则，执行内联的 JavaScript 代码
      loadScriptText(script.innerHTML)
    }

    // 删除已加载的片段
    tempDivDom.removeChild(script)
  })
  Array.from(tempDivDom.getElementsByTagName('noscript')).forEach(noscript => {
    // 如果该 script 元素有 src 属性，则动态引入外部 JavaScript
    let scriptText = noscript.innerHTML
    if (scriptText && scriptText.trim()) {
      let scriptDom = document.createElement('noscript')
      scriptDom.innerHTML = scriptText
      scriptDom.innerText = scriptText
      loadScriptDom(scriptDom)
    }
    // 删除已加载的片段
    tempDivDom.removeChild(noscript)
  })
  // 将剩余未经 script 包裹的片段加载
  loadScriptText(tempDivDom.innerHTML)
}



// WEBPACK FOOTER //
// ./src/utils/utils.js